// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__1x9of","gallery-section":"classes_gallery-section__2GfEs","buy-set-section":"classes_buy-set-section__te5L0"};